import { MDXLayout as Layout } from "@/shared/components/MDX/MDXLayout";
import { Alert } from "@/shared/components/MDX/MDXComponents";

# راهنمای اجرای MRP (برنامه‌ریزی مواد)

محاسبات MRP (Material Requirements Planning) نیازمندی‌های مواد اولیه را بر اساس برنامه‌های کلان (MPS) و ساختار محصول (BOM) استخراج می‌کند.

## ۱. اجرای محاسبه
با اجرای یک MRP جدید، سیستم موجودی انبارها را بررسی کرده و کسری مواد اولیه برای تولیدات آینده را شناسایی می‌کند.

## ۲. مشاهده نتایج
در نتایج MRP، لیست دقیق موادی که باید خریداری یا تولید شوند همراه با تاریخ نیاز آنها نمایش داده می‌شود.

export default Layout;
